/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { BaseAction } from '../../types/base-action.type';
import * as actions from 'src/types/user-action.type';

interface AuthUserType {
  licenses: any,
  isSetting?: boolean,
  error?: any,
  info?: any,
};

const initialState = {
  licenses: null,
  info: null,
  isSetting: false,
  error: null,
};

export const userReducer = (
  state: AuthUserType = initialState,
  action: BaseAction
) => {
  switch (action.type) {
    case actions.GET_USER_LICENSES:
      return {...state, isSetting: true, error: null}
    case actions.GET_USER_LICENSES_SUCCESS:
      return {
        ...state,
        licenses: action.payload,
        isSetting: false,
        error: null,
      };
    case actions.GET_USER_LICENSES_ERROR:
      return {
        ...state,
        isSetting: false,
        error: action.payload
      };
    case actions.GET_USER_INFO:
      return {...state, isSetting: true, error: null}
    case actions.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        info: action.payload,
        isSetting: false,
        error: null,
      };
    case actions.GET_USER_INFO_ERROR:
      return {
        ...state,
        isSetting: false,
        error: action.payload
      };
    default:
      return state
  }
};
